export interface IAmendTransaction {
  createById: string;
  transactionId: string;
  amendReasonId: number;
  userPin: number;
  witnessPin: number;
  addedQuantity: number;
  rxNumber?: string;
  patientName?: string;
  transactionDate: Date;
  isBackCountMatches?: boolean;
}

export class TransactionAmendment implements IAmendTransaction {
  createById = '';
  transactionId = '';
  amendReasonId = -1;
  userPin = -1;
  witnessPin = -1;
  addedQuantity = -1;
  rxNumber = null;
  patientName = null;
  mostRecentTransactionId?: string;
  transactionDate = new Date();
  amendReasonOtherDescription?: string;
  isBackCountMatches?: boolean;
}
